import { Button } from '@shared/components/ui/button';
import { FC, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons';
import { DropdownActions } from '../interaction/DropdownActions';
import { HistoryModal } from '../modals/HistoryModal';
import type { ModalCenterRef } from '@shared/components/ui/ModalCenter';
import type { Order } from '../../models/Order';

interface HeaderButtonsProps {
  order: Order | null;
  onActionSuccess: () => void;
}

export const HeaderButtons: FC<HeaderButtonsProps> = ({ order, onActionSuccess }) => {
  const historyModalRef = useRef<ModalCenterRef>(null);

  const handleOpenHistory = () => {
    historyModalRef.current?.openModal();
  };

  return (
    <>
      <div className="flex justify-end gap-2 absolute top-2 right-6">
        <Button variant="outline" size="icon" onClick={handleOpenHistory} className="bg-card-bg">
          <FontAwesomeIcon icon={faClockRotateLeft} className="!w-3 !h-3" />
        </Button>
        <DropdownActions order={order} onActionSuccess={onActionSuccess} />
      </div>
      <HistoryModal ref={historyModalRef} />
    </>
  );
};
